import i18n from "i18next";

import type { defaultLanguage } from "./languages";
import { ar, en, ru } from "./locales";

const RESOURCES = {
  ar,
  en,
  ru,
} as const;

// NOTE: NSAI-5266 — the generated `pipedreamTools` namespace is a Pipedream tool-name
// → title lookup (~600 entries), consumed dynamically by the tool-message resolver —
// not fixed UI copy with stable keys. Type it as an index-signature `Record` (same
// "declare the Record type" approach as `TToolMessageMap`) so those ~600 tool names
// don't explode the i18next key-literal union and a dynamic tool name type-checks
// against it. Every other namespace keeps its literal-key typing for strict checks.
type TResources = (typeof RESOURCES)[typeof defaultLanguage];
export interface IAppResources extends Omit<TResources, "pipedreamTools"> {
  pipedreamTools: Record<string, string>;
}

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: IAppResources;
    strictKeyChecks: true;
  }
}

export default i18n;
export { RESOURCES };
export { getActiveLanguage } from "./active-language";
export * from "./languages";
